<template>
	<div>
		<div class="banner">
			<navigator :index="0"></navigator>
			<!-- <div class="navigationBg">
				<header class="navigation">
					<h1>
						<img class="logo" alt="筑橙科技" src="../resource/images/logo.svg">
					</h1>
					<nav class="navigator">
						<div class="navigatorText acitve">首页
							<div class="block activeBlock"></div>
						</div>
						<div @click="reminder()" class="navigatorText">产品中心
							<div class="block"></div>
						</div>
						<router-link to="/example01" class="navigatorText">应用案例
							<div class="block"></div>
						</router-link>
						<router-link to="/news01" class="navigatorText">筑橙新闻
							<div class="block"></div>
						</router-link>
						<router-link to="/aboutUs" class="navigatorText">关于我们
							<div class="block"></div>
						</router-link>
						<div @click="open()" class="navigatorText">在线联系
							<div class="block"></div>
						</div>
					</nav>
				</header>
			</div> -->
			<div class="bannerSlide">
				<div class="bannerItem">
					<img src="../resource/images/img03.png">
				</div>
			</div>
		</div>
		<div class="content">
			<h2 class="title">关于筑橙</h2>
			<h3 class="subTitle">致力于成为全球建筑机器人领域的领导者</h3>
			<p class="paragraph">
				筑橙科技（深圳）有限公司（以下简称为“筑橙科技”）成立于2018年，是一家致力于用机器人技术推动产业革新，为建筑施工产业提供智能施工解决方案的高新技术企业。筑橙科技将人工智能、环境感知、深度学习、伺服控制等核心技术应用到建筑施工领域，自主开发多款建筑机器人产品，其中外墙智能喷涂机器人已经实现产业化应用
				，能够大幅降低高空作业中的安全风险...
			</p>
		</div>
		<div style="text-align: center;margin-top:40px;">
			<router-link :to="{name:'aboutUs'}" class="more">了解更多></router-link>
		</div>
		<div class="product">
			<div class="productTitle">产品中心</div>
			<div class="productItem">
				<div class="productItemDiv">
					<img class="productImg" src="../resource/images/img05.png" alt="智能外墙喷涂机器人">
				</div>
				<div class="productParagraph">
					<h2 class="productParagraphTitle">
						<img class="paragraphTitleImg" src="../resource/images/img04.png" alt="智能外墙喷涂机器人">
						<span style="position: relative;z-index:2;">智能外墙喷涂机器人</span>
					</h2>
					<div class="article">
						智能外墙喷涂机器人是服务于外墙涂料施工的特种建筑机器人，实现了高空无人化涂料施工。基于风控稳定算法和独特的喷涂结构设计，已具备喷涂全体系涂料功能，可以实现更高效的底漆、中涂、面漆（包括平面多彩）、罩光漆自动化喷涂。模块化设计和高可靠性的工业控制系统，大大降低施工安全风险，操作更为简单方便，降低对操作人员的能力要求。
					</div>
				</div>
			</div>
		</div>
		<div class="product">
			<div class="productTitle">产品特点</div>
			<div class="productCharacteristic">
				<div class="productCharacteristicItem">
					<img class="productCharacteristicImg" src="../resource/images/img08.svg">
					<div class="productCharacteristicDiv">
						<h4 class="productCharacteristicTitle">安全</h4>
						<p class="productCharacteristicText">无人施工，解决高坠危险</p>
					</div>
				</div>
				<div class="productCharacteristicItem">
					<img class="productCharacteristicImg" src="../resource/images/img09.svg">
					<div class="productCharacteristicDiv">
						<h4 class="productCharacteristicTitle">智能</h4>
						<p class="productCharacteristicText">人性设计，操作简便易学</p>
					</div>
				</div>
				<div class="productCharacteristicItem">
					<img class="productCharacteristicImg" src="../resource/images/img10.png">
					<div class="productCharacteristicDiv">
						<h4 class="productCharacteristicTitle">高效</h4>
						<p class="productCharacteristicText">稳定快速，施工高效质优</p>
					</div>
				</div>
				<div class="productCharacteristicItem">
					<img class="productCharacteristicImg" src="../resource/images/img11.svg">
					<div class="productCharacteristicDiv">
						<h4 class="productCharacteristicTitle">通用</h4>
						<p class="productCharacteristicText">化繁为简，适用全部涂料</p>
					</div>
				</div>
			</div>
		</div>
		<div class="product">
			<div class="productTitle">应用案例</div>
			<div class="exampleDiv">
				<div class="exampleItem">
					<div class="exampleImgDiv">
						<img class="exampleImg" src="../resource/images/img12.png" alt="建发·厦门文澜和著">
						<div class="exampleImgText">建发·厦门文澜和著</div>
					</div>
					<div class="exampleText">筑橙科技与中建海峡建设发展有限公司在建发·厦门文澜和著项目高层业态开展合作，进行外墙涂料机器人喷涂工作。</div>
					<div style="margin-bottom:20px;display: flex;justify-content: center;">
						<router-link to="/example01" class="more">了解更多></router-link>
					</div>
				</div>
				<div class="exampleItem">
					<div class="exampleImgDiv">
						<img class="exampleImg" src="../resource/images/img13.png" alt="瑞安金茂悦">
						<div class="exampleImgText">瑞安金茂悦</div>
					</div>
					<div class="exampleText">
						筑橙科技与中国金茂在瑞安金茂悦02-41地块20#、21#楼达成合作，开展外墙涂料机器人喷涂试点工作。</div>
					<div style="margin-bottom:20px;display: flex;justify-content: center;">
						<router-link to="/example02" class="more">了解更多></router-link>
					</div>
				</div>
			</div>
		</div>
		<div class="product">
			<h2 class="productTitle">筑橙新闻</h2>
			<div class="news">
				<div @click="go(index,item.id)" v-for="(item,index) in list" :key="index" v-if="index <= 1" class="newsItem">
					<h3 class="newsTitle">{{item.titleText}}</h3>
					<div class="newsDate">{{item.createTime}}</div>
					<p class="newsContent">
						{{item.contentText}}
					</p>
					<div class="watchMore">查看更多 >></div>
				</div>
				<!-- <router-link class="newsItem" to="/news02">
					<h3 class="newsTitle">“二合一”喷涂机器人上工啦</h3>
					<div class="newsDate">2022年3月31日</div>
					<p class="newsContent">
						随着冬奥会渐进尾声，北方建筑工地陆续恢复施工。筑橙科技“二合一”喷涂机器人也奔赴山东济宁工地现场，开工啦！本次升级“二合一”后，同一台机器人既可以喷涂乳液型外墙涂料，也可以喷涂颗粒型外墙涂料...
					</p>
					<div class="watchMore">查看更多 >></div>
				</router-link> -->
			</div>
		</div>
		<!-- foot -->
		<foot></foot>
	</div>

</template>

<script>
	import navigator from "../components/navigator"
	import foot from "../components/foot"
	import axios from 'axios'
	import url from "../url.js"
	export default {
		components: {
			foot,
			navigator
		},
		name: 'index',
		data() {
			return {
				list: [], //新闻列表
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			go(index,id) {
				console.log("index:", index)
				this.$session.set("currentIndex", index);
				this.$router.push({
					name: "news",
					query: {
						id: id,
						isPerview: false,
						currentIndex: index
					}
				})
			},
			open() {
				window.open("http://qingflow.com/f/a445638c?qfchannel=Website")
				// window.location.href = "http://qingflow.com/f/a445638c?qfchannel=Website"
			},
			reminder() {
				this.hint.hint()
			},
			getList() {
				axios.get(`${url.develop}/website/mobile/journalismFindPage`, {
					params: {
						pageNum: 1,
						pageSize: 999999
					}
				}).then(res => {
					console.log("res:", res)
					if (res.data.code) {

						let regex = /(<([^>]+)>)/ig

						for (let i = 0; i < res.data.data.content.length; i++) {
							res.data.data.content[i].titleText = res.data.data.content[i].title.replace(regex, "")
								.replace(/&nbsp;/ig, '').replace(/(^\s*)|(\s*$)/g, "");
							res.data.data.content[i].contentText = res.data.data.content[i].content.replace(regex,
								"").replace(/&nbsp;/ig, '').replace(/(^\s*)|(\s*$)/g, "");
						}

						this.list = res.data.data.content


						console.log("list:", this.list)
					}
				})
			},
		}
	}
</script>


<style scoped>
	.watchMore {
		line-height: 28px;
		font-size: 16px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: right;
		color: #ea5b24;
		padding-right: 20px;
		box-sizing: border-box;
	}

	.other {
		padding: 76px 0;
	}

	.otherRight {
		display: flex;
	}

	.otherRightItem {
		margin-right: 80px;
	}

	.otherRightItem:nth-last-child(1) {
		margin-right: 0;
	}

	.otherRightItemText {
		line-height: 20px;
		font-size: 14px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #858585;
		margin-bottom: 20px;
	}

	.otherRightItemTitle {
		margin-bottom: 13px;
		line-height: 25px;
		font-size: 18px;
		font-family: PingFang SC, PingFang SC-Bold;
		font-weight: 700;
		text-align: left;
		color: #fff;
		line-height: 34px;
	}

	.wechat {
		width: 16px;
		height: 16px;
	}

	.linkOur {
		line-height: 22px;
		font-size: 16px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #fff;
		line-height: 38px;
		margin-left: 10px;
	}

	.otherLeft {
		display: flex;
		align-items: center;
	}

	.other {
		background: #262626;
		height: 299px;
		display: flex;
	}

	.copyright {
		text-align: center;
		width: 100%;
		line-height: 86px;
		height: 86px;
		font-size: 14px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		color: #707070;
		background: #191919;
	}

	.news {
		display: block;
	}

	.newsContent {
		line-height: 24px;
		font-size: 16px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		/* color: #999; */
		color: #666;
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.newsDate {
		line-height: 14px;
		font-size: 14px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #bbb;
		margin-bottom: 10px;
	}

	.newsTitle {
		line-height: 28px;
		font-size: 24px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #333;
		margin-bottom: 10px;
	}

	.newsItem {
		cursor: pointer;
		display: block;
		width: 1200px;
		margin: 0px auto 20px auto;
		padding: 20px 15px 20px 15px;
		box-sizing: border-box;
		background: rgba(234, 91, 36, 0.03);
		border-radius: 12px;
	}

	.exampleImg {
		position: absolute;
		display: block;
		width: 100%;
		height: auto;
		left: 0;
		top: 0;
	}

	.exampleImgDiv {
		position: relative;
		width: 100%;
		height: 380px;
		overflow: hidden;
	}

	.exampleItem {
		width: 580px;
		border: 1px solid #dddddd;
		border-radius: 12px;
		overflow: hidden;
	}

	.exampleDiv {
		display: flex;
		justify-content: space-between;
	}

	.exampleText {
		margin: 40px auto 30px auto;
		width: 520px;
		height: 51px;
		font-size: 14px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #666666;
		line-height: 24px;
	}

	.exampleImgText {
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 60px;
		line-height: 60px;
		font-size: 20px;
		font-family: PingFang SC, PingFang SC-Bold;
		font-weight: 700;
		text-align: left;
		color: #fff;
		letter-spacing: 0.96px;
		background: rgba(0, 0, 0, 0.65);
		padding: 0 30px;
		box-sizing: border-box;

	}

	.productCharacteristicImg {
		width: 60px;
		height: 60px;
	}

	.productCharacteristicItem {
		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.productCharacteristicTitle {
		line-height: 42px;
		font-size: 30px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: center;
		color: #6b7278;
		margin-bottom: 6px;
		margin-top: 39px;
	}

	.productCharacteristicText {
		line-height: 20px;
		font-size: 14px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: center;
		color: #6b7278;
	}

	.productCharacteristic {
		display: flex;
		justify-content: space-around;
		align-items: center;
	}

	.article {
		margin-top: 20px;
		width: 505px;
		font-size: 14px;
		font-weight: 400;
		text-align: left;
		color: #666;
		line-height: 24px;
	}

	.productItem {
		display: flex;
		justify-content: space-between;
		align-items: center;
		/* margin-top: 60px; */
	}

	.paragraphTitleImg {
		position: absolute;
		left: -9px;
		top: 0;
		width: 31px;
		height: 31px;
		z-index: 1;
	}

	.productParagraphTitle {
		position: relative;
		height: 37px;
		line-height: 37px;
		font-size: 26px;
		font-family: PingFang SC, PingFang SC-Bold;
		font-weight: 700;
		text-align: left;
		color: #333333;
	}

	.productItemDiv {
		overflow: hidden;
		width: 596px;
		/* border: 1px solid #dddddd; */
		border-radius: 8px;
		box-sizing: border-box;
		background-color: #FDFDFD;
	}

	.productImg {
		display: block;
		width: 100%;
		height: auto;
	}

	.product {
		width: 1200px;
		margin: 60px auto;
	}

	.productTitle {
		margin-bottom: 30px;
		line-height: 56px;
		font-size: 40px;
		font-weight: 800;
		text-align: left;
		color: #333;
	}

	.more {
		padding: 0 27px;
		display: inline-block;
		height: 42px;
		line-height: 42px;
		font-size: 14px;
		font-weight: 400;
		text-align: center;
		color: #ea5b24;
		border: 1px solid #ea5b24;
		border-radius: 6px;
		box-sizing: border-box;
	}

	.paragraph {
		margin-top: 30px;
		line-height: 18px;
		font-size: 14px;
		font-weight: 400;
		text-align: left;
		/* color: #707070; */
		color: #666;
		line-height: 24px;
	}

	.subTitle {
		margin-top: 4px;
		line-height: 27px;
		font-size: 20px;
		font-weight: 400;
		color: #707070;
	}

	.content {
		width: 1200px;
		margin: 0px auto;
		overflow: hidden;
	}

	.title {
		line-height: 56px;
		font-size: 40px;
		font-family: PingFang SC, PingFang SC-Heavy;
		font-weight: 800;
		text-align: left;
		color: #333;
		margin-top: 60px;
	}

	.banner {
		position: relative;
	}

	.bannerItem img {
		display: block;
		width: 100%;
		height: auto;
	}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue